import GetAttachmentTextPreviewReadMode from 'owa-service/lib/contract/GetAttachmentTextPreviewReadMode';
import TextPreviewStatus from 'owa-service/lib/contract/TextPreviewStatus';
import getAttachmentTextPreviewOperation from 'owa-service/lib/operation/getAttachmentTextPreviewOperation';
import RequestOptions from 'owa-service/lib/RequestOptions';
import { trace } from 'owa-trace';

export default async function getAttachmentTextPreview(
    attachmentId: string,
    requestOptions: RequestOptions,
    readMode: GetAttachmentTextPreviewReadMode,
    actionSource?: string
): Promise<string> {
    const errorToThrow: GetAttachmentTextPreviewError = {
        error: null,
        errorMessage:
            'Something went wrong while the document preview was being created. Please try again later.',
    };

    try {
        // if action source is provided, add it to the client action name header of the call.
        if (actionSource) {
            const actionName: string = 'getAttachmentTextPreview' + actionSource;
            requestOptions = requestOptions || {};
            requestOptions.headers = requestOptions.headers || new Headers();
            requestOptions.headers.set('X-OWA-ActionName', actionName);
        }

        const response = await getAttachmentTextPreviewOperation(
            { AttachmentId: attachmentId, ReadMode: readMode },
            requestOptions
        );
        if (response && response.Status === TextPreviewStatus.Success) {
            return response.Content;
        } else {
            const status = response?.Status || TextPreviewStatus.UnknownError;
            switch (status) {
                case TextPreviewStatus.NotFound:
                    errorToThrow.errorMessage = 'The attachment has been moved or deleted.';
                    break;
                case TextPreviewStatus.InvalidRequest:
                    errorToThrow.errorMessage =
                        'Something went wrong while the document preview was being created. Please try again later.';
                    break;
                case TextPreviewStatus.UnknownError:
                default:
                    errorToThrow.errorMessage =
                        'Something went wrong while the document preview was being created. Please try again later.';
                    break;
            }

            errorToThrow.error = new Error(
                `getAttachmentTextPreview failed with status: ${status}`
            );
        }
    } catch (error) {
        trace.warn(`getAttachmentTextPreview failed with error: ${error}`);
        errorToThrow.error = error;
    }

    throw errorToThrow;
}

export interface GetAttachmentTextPreviewError {
    errorMessage: string;
    error: Error;
}
